// store/thunks/auth/select2FAMethodThunk.ts
import { createAppAsyncThunk } from '@/store/thunks/createAppAsyncThunk';
import type { TwoFactorMethod } from '@/types/auth/Auth';
import type { VerificationDTO } from '@/types/auth/AuthDTOs';

export const select2FAMethodThunk = createAppAsyncThunk<
  VerificationDTO,
  { method: TwoFactorMethod },
  { rejectValue: { message: string } }
>(
  'auth/select2FAMethod',
  async({ method }, { getState, extra: { authService }, rejectWithValue }) => {
    const state = getState();
    const twoFactorToken = state.auth.twoFactorToken;

    if (twoFactorToken === undefined) {
      return rejectWithValue({ message: 'Missing session token' });
    }

    try {
      return await authService.selectTwoFactorMethod({ twoFactorToken, method });
    } catch (caught) {
      const message = caught instanceof Error ? caught.message : 'Failed to select 2FA method';
      return rejectWithValue({ message });
    }
  }
);
